module.exports = __webpack_public_path__ + "img/fig7.2.b056d493.png";